// extracted by mini-css-extract-plugin
export default {"checkout-summary":"SummaryStudents--checkout-summary--9jve9","checkoutSummary":"SummaryStudents--checkout-summary--9jve9"};